import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerCityAll: [],
  insurerCity: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerCitySlice = createSlice({
  name: "insurerCity",
  initialState,
  reducers: {
    setInsurerCityAll: (state, action) => {
      state.insurerCityAll = action.payload;
    },
    setInsurerCity: (state, action) => {
      state.insurerCity = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerDistrictAll,
  setInsurerDistrict,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerCitySlice.actions;

export default insurerCitySlice.reducer;
